import { Component, OnInit, Inject, Input } from "@angular/core";
import { Location } from "@angular/common";
import { Validators, FormBuilder, FormControl } from "@angular/forms";
import { AuthService } from "src/providers/auth.service";
import { InstituitionProvider } from "../../providers/institution.service";
import { Router, ActivatedRoute } from "@angular/router";
import { disable, error } from "@rxweb/reactive-form-validators";
import { InstitutionModel } from "../../models/institution.model";
import { UserTypeModel } from "src/models/usertypes.model";
import { element } from "@angular/core/src/render3";
import { resolve } from "url";
// import { ListInstitutionComponent } from "../list-institution/list-institution.component";
import { UtilsProvider } from "../../commons/utils";
import { UserService } from "src/providers/user.service";
import { MenuService } from "src/providers/menu.service";
import { ENV } from "src/environments/environment-variables.token";
import { Cmyk, Rgba, ColorPickerService } from "ngx-color-picker";

export interface DialogData {
	message: string;
}
@Component({
	selector: "app-update-institution",
	templateUrl: "./update-institution.component.html",
	styleUrls: ["./update-institution.component.scss"]
})
export class UpdateInstitutionComponent implements OnInit {
	public institution: string;
	public inst: any;
	public gtall: any;
	public zoom = 12;
	public logoImage: any;
	public institutionId: any;
	public configInsitution = [
		{ identifier: "overtime", value: false },
		{ identifier: "checkin", value: false },
		{ identifier: "checkweb", value: false },
		{ identifier: "additionalHours", value: false },
		{ identifier: "checkoutManual", value: false },
		{ identifier: "photoCheckin", value: false },
		{ identifier: "photoCheckinWeb", value: false },
		{ identifier: "gpsCheckin", value: false },
		{ identifier: "faceIdCheckin", value: false }
	];
	message: string;
	public type: any;
	// public userTypes: {};
	public selectedUserType = [];
	public newInsitution: any;
	public checkBoxList = [
		{ value: "overtime", text: "Permitir solicitação adicional de horas de plantão ao coordenador", checked: false },
		{ value: "checkin", text: "Habilitar Check-in App", checked: false },
		{ value: "checkweb", text: "Habilitar Check-in Web", checked: false },
		{ value: "additionalHours", text: "Limite de horas adicionais do checkout manual", checked: false },
		{ value: "checkoutManual", text: "Checkout manual obrigatorio", checked: false },
		{ value: "photoCheckin", text: "Foto no Check-in App", checked: false },
		{ value: "photoCheckinWeb", text: "Foto no Check-in Web", checked: false },
		{ value: "gpsCheckin", text: "GPS no Check-in", checked: false },
		{ value: "faceIdCheckin", text: "Face Id / Biometria no Check-in", checked: false }
	];
	// initial center position for the map
	public lat = -23.550525185120367;
	public lng = -46.62414890025252;
	public radius = 500;
	public infoData: any;
	public page = 0;
	public limit = 10;
	public newType: any;
	public allowedAddHoursForm: any;
	public selectedItems: any[] = [];
	public multiSelectSettings: any;
	public userInfo: any;
	public address: "";
	public district: "";
	public city: "";
	public state: "";
	public color = "";
	public cmyk: Cmyk = new Cmyk(0, 0, 0, 0);
	public usersList: any;

	constructor(
		public activatedRoute: ActivatedRoute,
		public formBuilder: FormBuilder,
		public auth: AuthService,
		public instModel: InstitutionModel,
		public institutionService: InstituitionProvider,
		public router: Router,
		public userTypeModel: UserTypeModel,
		public utils: UtilsProvider,
		public usersService: UserService,
		public menuService: MenuService,
		public _location: Location,
		public cpService: ColorPickerService,
		@Inject(ENV) public ENV: any
		// public list: ListInstitutionComponent,


	) { }
	public institutionForm: any;
	public institutionStep: any;
	@Input() userTypes: any;
	@Input() update = false;
	// ngOnInit() { }
	ngAfterViewInit() {
		this.ENV.pageTitle = "Atualizar Instituição";
	}
	async ngOnInit() {

		const storage = localStorage.getItem("user");
		this.userInfo = JSON.parse(storage);
		this.Init();
	}
	async Init() {
		const self = this;
		this.multiSelectSettings = {
			singleSelection: false,
			idField: "_id",
			textField: "name",
			itemsShowLimit: 5,
			allowSearchFilter: true,
			enableCheckAll: false
		};
		this.activatedRoute.queryParams.subscribe(async params => {
			const [errFindUsers, usersList] = await this.utils.tryCatch(this.usersService.getAll({ page: this.page, perPage: this.limit }));
			if (errFindUsers) {
				return this.utils.toast({
					message: "Ocorreu um erro ao buscar usuários, por favor tente novamente mais tarde.",
					duration: 8000
				});
			}
			const idxMyUser = usersList.items.findIndex(el => String(el._id) === String(this.userInfo._id));
			if (idxMyUser > -1) { usersList.items.splice(idxMyUser, 1); }
			// this.usersList = usersList.items;
			this.usersList = [];
			self.setUsersList(usersList.items);

			this.institutionService.getById({ id: params._id })
				.then((result: any) => {
					this.institutionId = params._id;
					this.inst = result[0];
					this.type = result[0].userTypes;
					this.selectedUserType = this.type;
					this.newInsitution = params.newInstitution;

					const title = new FormControl("", Validators.compose([Validators.required]));
					const description = new FormControl("", Validators.compose([Validators.required]));
					const cep = new FormControl("", undefined);
					const address = new FormControl("", Validators.compose([Validators.required]));
					const address_number = new FormControl("", Validators.compose([Validators.required]));
					const district = new FormControl("", Validators.compose([Validators.required]));
					const city = new FormControl("", Validators.compose([Validators.required]));
					const state = new FormControl("", Validators.compose([Validators.required]));
					const radius = new FormControl("", Validators.compose([Validators.required]));
					const checkBoxList = new FormControl("", undefined);
					const allowedAdditionalHours = new FormControl("", undefined);
					const validIps = new FormControl("", undefined);
					const docs = new FormControl("", undefined);
					const clt = new FormControl("", undefined);
					const coop = new FormControl("", undefined);
					const pj = new FormControl("", undefined);
					const longitude = new FormControl("", Validators.compose([Validators.required]));
					const latitude = new FormControl("", Validators.compose([Validators.required]));
					const serviceDescription = new FormControl("", Validators.compose([Validators.required]));
					const logoImage = new FormControl("", undefined);
					const users = new FormControl("", Validators.compose([Validators.required]));
					const color = new FormControl("", undefined);

					allowedAdditionalHours.disable();
					this.institutionStep = 0;
					this.institutionForm = [
						{
							fields: [
								{
									name: "title",
									type: "text",
									placeholder: "Nome da instituição",
									cols: "col-lg-6 col-md-6 col-sm-3",
									blurCallback() { }
								},
								{
									name: "description",
									type: "text",
									cols: "col-lg-6 col-md-6 col-sm-3",
									placeholder: "Descrição da instituição",
									blurCallback() { }
								},
								{
									name: "cep",
									type: "maskCep",
									placeholder: "CEP",
									cols: "col-lg-6 col-md-6 col-sm-12",
									blurCallback() {
										console.log("teste cep", self.institutionForm[0].builder.controls.cep.value);
										let cepValue = self.institutionForm[0].builder.controls.cep.value;
										if (cepValue.length !== 0) {
											cepValue = cepValue.replace(/\W+/g, "");
											self.buscarCep(cepValue);
										}
									}
								},
								{
									name: "address",
									type: "text",
									cols: "col-lg-6 col-md-6 col-sm-12",
									placeholder: "Endereço",
									blurCallback() { }
								},
								{
									name: "address_number",
									type: "number",
									cols: "col-lg-6 col-md-6 col-sm-3",
									placeholder: "Numero",
									blurCallback() { }
								},
								{
									name: "district",
									type: "text",
									cols: "col-lg-6 col-md-6 col-sm-3",
									placeholder: "Bairro",
									blurCallback() { }
								},
								{
									name: "city",
									type: "text",
									cols: "col-lg-6 col-md-6 col-sm-3",
									placeholder: "Cidade",
									blurCallback() { }
								},
								{
									name: "state",
									type: "text",
									cols: "col-lg-4 col-md-6 col-sm-4",
									placeholder: "Estado",
									blurCallback() { }
								},
								{
									name: "radius",
									type: "number",
									cols: "col-lg-6 col-md-6 col-sm-6",
									placeholder: "Raio de Check-in",
									blurCallback() { }
								},
								{
									name: "users",
									type: "searchselect",
									placeholder: "Selecione os administradores desta instituição",
									cols: "col-lg-4 col-md-6 col-sm-4",
									data: this.usersList,
									dropdownSettings: this.multiSelectSettings,
									onItemSelect: (event, item) => {
										this.selectedItems.push({ _id: event._id });
									},
									onItemDeSelect: (event, item) => {
										const idx = this.selectedItems.findIndex(el => String(el._id) === String(event._id));
										if (idx > -1) { this.selectedItems.splice(idx, 1); }
									},
									async onFilterChange(event) {
										// console.log("event search", event);
										const [errFindUsers2, usersList2] = await self.utils.tryCatch(
											self.usersService.getAll({ page: self.page, perPage: self.limit, find: event })
										);
										if (errFindUsers2) {
											return self.utils.toast({
												message: "Ocorreu um erro ao buscar usuários, por favor tente novamente mais tarde.",
												duration: 8000
											});
										}
										const idxMyUser2 = usersList2.items.findIndex(el => String(el._id) === String(self.userInfo._id));
										if (idxMyUser2 > -1) { usersList2.items.splice(idxMyUser2, 1); }
										self.usersList = [];
										// self.usersList.push(...usersList2.items);
										self.setUsersList(usersList2.items);
										console.log("self.usersList", self.usersList	);
									}
								},
								{
									name: "checkBoxList",
									type: "checkbox",
									placeholder: "Selecione um grupo",
									cols: "col-lg-12 col-md-12 col-sm-6",
									options: {
										fields: {
											value: "value",
											text: "text",
										},
										items: this.checkBoxList
									},
									clickCallback(event) {
										self.saveCheckBoxValues(event)
										if (event.value == "additionalHours") {
											allowedAdditionalHours.disabled ? allowedAdditionalHours.enable() : allowedAdditionalHours.disable()
											allowedAdditionalHours.setValue(null)
										}
									}
								},
								{
									name: "allowedAdditionalHours",
									type: "number",
									label: "Tolerância de horas adicionais",
									placeholder: "Total de horas adicionais permitidas por plantão",
									cols: "col-lg-6 col-md-6 col-sm-4",
									blurCallback() { }
								},
								{
									name: "validIps",
									type: "textarea",
									cols: "col-lg-12 col-md-12 col-sm-4",
									label: "IPs válidos",
									placeholder: "IPs válidos (separados por vírgula)",
									blurCallback() { }
								},
								{
									name: "docs",
									type: "textarea",
									cols: "col-lg-12 col-md-12 col-sm-4",
									label: "Documentos Requeridos",
									placeholder: "Documentos Requeridos (separados por vírgula)",
									blurCallback() { }
								},
								{
									name: "clt",
									type: "number",
									cols: "col-lg-6 col-md-6 col-sm-4",
									label: "Limite de horas semanais contrato Efetivo",
									placeholder: "Ex: 60 horas/semana",
									blurCallback() { }
								},
								{
									name: "pj",
									type: "number",
									cols: "col-lg-6 col-md-6 col-sm-4",
									label: "Limite de horas semanais contrato PJ",
									placeholder: "Ex: 60 horas/semana",
									blurCallback() { }
								},
								{
									name: "coop",
									type: "number",
									cols: "col-lg-6 col-md-6 col-sm-4",
									label: "Limite de horas semanais contrato Cooperado",
									placeholder: "Ex: 60 horas/semana",
									blurCallback() { }
								},
								{
									name: "longitude",
									type: "number",
									label: "Longitude",
									placeholder: "Longitude",
									cols: "col-lg-6 col-md-6 col-sm-3",
									blurCallback() { }
								},
								{
									name: "latitude",
									type: "number",
									label: "Latitude",
									placeholder: "Latitude",
									cols: "col-lg-6 col-md-6 col-sm-3",
									blurCallback() { }
								},
								{
									name: "serviceDescription",
									type: "textarea",
									label: "Mensagem para o usuário cadastrado",
									placeholder: "Texto que será exibido ao usuário ao ingressar na instituição",
									cols: "col-lg-12 col-md-12 col-sm-6",
									blurCallback() { }
								},
								{
									name: "logoImage",
									type: "imgng2",
									label: "Logo da Instituição",
									placeholder: "Edite a logo da Instituição",
									cols: "col-lg-6 col-md-6 col-sm-4",
									multiple: false,
									onAdded(event) {
										self.getBase64(event.file).then(res => {
											self.logoImage = res;
											self.uploadImage(res).then(r => {
												console.log(r);
											});
										});
									},
									onRemoved(event) {
										this.getBase64(event);
									}
								}

							],
							builder: this.formBuilder.group({
								title,
								description,
								cep,
								address,
								address_number,
								district,
								city,
								state,
								radius,
								// userTypes,
								checkBoxList,
								allowedAdditionalHours,
								validIps,
								docs,
								clt,
								coop,
								pj,
								longitude,
								latitude,
								serviceDescription,
								logoImage,
								users,
								color
							}),
							validation_messages: {
								title: [
									{ type: "required", message: "Preencha o titulo" },
								],
								description: [
									{ type: "required", message: "Preencha a descrição" },
								],
								cep: [{
									type: "required", message: "Preencha o endereço"
								},
								{
									type: "pattern", message: "Nome deve conter somente letras."
								}],
								address: [{
									type: "required", message: "Preencha o endereço"
								}],
								address_number: [{
									type: "required", message: "Preencha o endereço"
								}],
								district: [{
									type: "required", message: "Preencha o endereço"
								}],
								city: [{
									type: "required", message: "Preencha o endereço"
								}],
								state: [{
									type: "required", message: "Preencha o endereço"
								}],
								radius: [{
									type: "required", message: "Preencha a distancia de checkin em numeros"
								}],
								// userTypes: [
								// 	{ type: "required", message: "Campo não pode estar vazio." },
								// ],
								checkBoxList: [
									{ type: "required", message: "Campo não pode estar vazio." },
								],
								users: [
									{ type: "required", message: "Campo não pode estar vazio." },
								],
								color: []
							},
						},
					];
					this.setValue();
				});
		});
	}
	setUsersList(users) {
		console.log("users", users);
		console.log("this.usersList", this.usersList);
		this.usersList = this.usersList.concat(...users);
		console.log("this.after", this.usersList);
	}

	buscarCep(cepValue) {
		console.log("cep", cepValue);
		if (cepValue.length === 8) {
			this.ENV.loading = true;
			this.institutionService.getCEP(cepValue).then(data => {
				this.address = data["logradouro"];
				this.district = data["bairro"];
				this.city = data["localidade"];
				this.state = data["uf"];
				console.log(this.address, this.district, this.city, this.state);
        console.log(data);


				this.institutionForm[0].builder.patchValue({
					address: this.address || "",
					city: this.city || "",
					district: this.district || "",
					state: this.state || ""
				});
				this.ENV.loading = false;
			});
		}
	}

	goBack() {
		this._location.back();
	}

	setValue() {
		this.color = this.inst["color"];
		const self = this;
		if (this.inst._id) {
			const result = this.inst;
			console.log("update result", result.cep);
			if (result) {
				const ut = [];
				result.userTypes.forEach(el => {
					ut.push(el._id);
				});
				this.setCheckBox(result.config);
				const mapCoords = {
					lat: this.getConfigValue(result.config, "latitude"),
					lng: this.getConfigValue(result.config, "longitude"),
					radius: this.getConfigValue(result.config, "radius"),
				};
				this.setMap(mapCoords);
        console.log('🔥️🔥️🔥️🔥️🔥️');
        console.log(mapCoords);
        console.log(this.lat);
        console.log(this.radius);




				this.institutionForm[0].builder.patchValue({
					_id: result.id || undefined,
					title: result.title || undefined,
					description: result.description || undefined,
					address: result.address || undefined,
					address_number: result.address_number || undefined,
					city: result.city || undefined,
					district: result.district || undefined,
					state: result.state || undefined,
					cep: result.cep || undefined,
					userTypes: ut,
					latitude: mapCoords.lat,
					longitude: mapCoords.lng,
					radius: mapCoords.radius,
					users: result.users.filter(el => String(el._id) !== String(this.userInfo._id)),
					validIps: this.getConfigValue(result.config, "validIps") || undefined,
					docs: this.getConfigValue(result.config, "requiredDocs") || undefined,
					allowedAdditionalHours: this.getConfigValue(result.config, "allowedAdditionalHours") || undefined,
					clt: this.getConfigValue(result.config, "cltHours") || undefined,
					coop: this.getConfigValue(result.config, "coopHours") || undefined,
					pj: this.getConfigValue(result.config, "pjHours") || undefined,
					serviceDescription: this.getConfigValue(result.config, "serviceDescription") || undefined,
					color: result.color || undefined
				});

				const i = this.checkBoxList.findIndex(x => x.value === "additionalHours");
				if (this.checkBoxList[i].checked) {
					this.institutionForm[0].builder.controls.allowedAdditionalHours.enable();
				}
				this.selectedItems = result.users.filter(el => String(el._id) !== String(this.userInfo._id));

			} else { this.setInitialValue(); }
		} else { this.setInitialValue(); }
	}

	setInitialValue() {
		this.institutionForm[0].builder.patchValue({
			latitude: this.lat,
			longitude: this.lng,
			radius: this.radius,
		});
	}

	setCheckBox(config) {
		this.checkBoxList.forEach(checkbox => {
			const idx = config.findIndex(x => x.identifier === checkbox.value);
			if (idx > -1 && config[idx].value && config[idx].value !== "false" && config[idx].value !== false) {
				checkbox.checked = true;
			}
		});

		this.configInsitution.forEach(checkbox => {
			const idx = config.findIndex(x => x.identifier === checkbox.identifier);
			if (idx > -1 && config[idx].value && config[idx].value !== "false" && config[idx].value !== false) {
				checkbox.value = true;
			}
		});
		return this.checkBoxList;
	}

	setMap(coords) {
		this.lat = Number(coords.lat);
		this.lng = Number(coords.lng);
		this.radius = Number(coords.radius);
	}

	getUserTypes(uT) {
		return uT && uT.items ? uT.items : uT;
	}

	getConfigValue(config, field) {
		const idx = config.findIndex(x => x.identifier === field);
		if (idx < 0) { return undefined; }
		return config[idx].value;
	}

	getBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = error => reject(error);
		});
	}

	saveCheckBoxValues(item) {
		this.configInsitution.forEach((element) => {
			if (element.identifier === item.value) { element.value = !element.value; }
		});
	}

	markerDragEnd(e) {
		this.institutionForm[0].builder.patchValue({
			latitude: e.coords.lat,
			longitude: e.coords.lng,
		});
	}

	radiusChange(e) {
		console.log("e", e);
    // if (e > 10000){
    //   e = 10000;
    // }

		this.institutionForm[0].builder.patchValue({
			radius: e,
		});
	}

	onSelectChange(event, item) {
		console.log(event);
		if (event.isUserInput) {
			if (event.source.selected) {
				this.onItemSelect(item);
			} else {
				this.onItemDeSelect(item);
			}
		}
	}

	onItemSelect(item: any, self = this) {
		self.selectedUserType.push(item);
	}

	onItemDeSelect(item: any, self = this) {
		const idx = self.selectedUserType.findIndex(x => x._id === item._id);
		self.selectedUserType.splice(idx, 1);
	}

	onSubmit(form) {
		// console.log("sadfdsafsdfa", this.institutionForm[0].builder);
		if (!this.institutionForm[0].builder.valid) {
			this.utils.toast({ message: "Preencha corretamente o formulário" });
			return false;
		}
		let cepSplit = this.institutionForm[0].builder.controls.cep.value;
		cepSplit = cepSplit.replace(/\-/g, "");

		// if (this.institutionForm[0].builder.controls.address.value === "") {
		// 	// console.log("erro", form);
		// 	return false;
		// }

		this.institutionForm[0].builder.controls.users.value = this.selectedItems;
		this.configInsitution.push({ identifier: "pjHours", value: this.institutionForm[0].builder.controls.pj.value });
		this.configInsitution.push({ identifier: "cltHours", value: this.institutionForm[0].builder.controls.clt.value });
		this.configInsitution.push({ identifier: "coopHours", value: this.institutionForm[0].builder.controls.coop.value });
		this.configInsitution.push({ identifier: "validIps", value: this.institutionForm[0].builder.controls.validIps.value });
		this.configInsitution.push({ identifier: "requiredDocs", value: this.institutionForm[0].builder.controls.docs.value });
		this.configInsitution.push({ identifier: "longitude", value: this.institutionForm[0].builder.controls.longitude.value });
		this.configInsitution.push({ identifier: "latitude", value: this.institutionForm[0].builder.controls.latitude.value });
		this.configInsitution.push({ identifier: "serviceDescription", value: this.institutionForm[0].builder.controls.serviceDescription.value });
		this.configInsitution.push({ identifier: "radius", value: this.institutionForm[0].builder.controls.radius.value });
		this.configInsitution.push({ identifier: "allowedAdditionalHours", value: this.institutionForm[0].builder.controls.allowedAdditionalHours.value });

		const infoData = {
			_id: this.inst._id,
			title: this.institutionForm[0].builder.controls.title.value,
			description: this.institutionForm[0].builder.controls.description.value,
			cep: cepSplit,
			address: this.institutionForm[0].builder.controls.address.value,
			address_number: this.institutionForm[0].builder.controls.address_number.value,
			district: this.institutionForm[0].builder.controls.district.value,
			city: this.institutionForm[0].builder.controls.city.value,
			state: this.institutionForm[0].builder.controls.state.value,
			logoImage: this.logoImage,
			config: this.configInsitution,
			users: this.selectedItems,
			color: this.institutionForm[0].builder.controls.color.value
		};

		this.infoData = infoData;
		const teste = this.userTypeModel.getNextData();
		console.log("TESTEEEEEEEEEE", teste);
		// // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", this.newInsitution);
		// if (JSON.parse(this.newInsitution)) {
		// 	this.institutionService.createInstitution(infoData).then((result: any) => {
		// 		console.log("create", result);
		// 		this.completeCreation(true);
		// 	}).catch((err: any) => {
		// 		const errType = err.status;
		// 		console.log(errType);
		// 	});
		// } else {
		// 	this.institutionService.updateInstitution(infoData).then((result: any) => {
		// 		console.log("update", result);
		// 		this.completeCreation(true);
		// 	}).catch((err: any) => {
		// 		const errType = err.status;
		// 		console.log(errType);
		// 	});
		// }
		this.institutionService.updateInstitution(infoData).then((result: any) => {
			const data = result.data;
			console.log("update", data);
			const institutionInfo = { institution_id: data._id, institution_title: data.title, ...data };
			const instJson = JSON.stringify(institutionInfo);
			localStorage.setItem("institution", instJson);
			this.completeCreation(true);
		}).catch((err: any) => {
			const errType = err.status;
			console.log(errType);
			return this.utils.toast({
				message: "Ocorreu um erro ao buscar por dados da instituição, tente novamente mais tarde.",
				action: "Ok",
				duration: 8000
			});
		});
	}

	completeCreation(creationComplete) {
		console.log("change page", creationComplete);
		this.menuService.gernerateMenu();
		this.router.navigate(["pages/listinstitution"]);
	}

	closeModal() {
		const modalErro = document.getElementById("modal-erro");
		const modalUpdate = document.getElementById("modal-update");
		modalErro.classList.remove("show-modal");
		modalUpdate.classList.remove("show-modal");
	}

	uploadImage(data: any) {
		return new Promise(async (resolve, reject) => {
			const [err, res] = await this.utils.tryCatch(this.institutionService.institutionAvatar({ _id: this.institutionId, photo: data }));
			if (err) {
				this.utils.toast({
					message: "Ocorreu um erro realizar o upload de imagem, tente novamente mais tarde.",
					action: "Ok",
					duration: 8000
				});
				reject(err);
			}
			// const savedImg = res && res.data ? res.data.photo : undefined;
			return resolve(res);
		}).catch(err => {
			console.log("UPLOAD IMAGE ERR: ", err);
			return this.utils.toast({
				message: "Ocorreu um erro realizar o upload de imagem, tente novamente mais tarde.",
				action: "Ok",
				duration: 8000
			});
		}
		);
	}

	onChangeColor(color: string): Cmyk {
		this.institutionForm[0].builder.patchValue({
			color: color || "#282B34"
		});
		return this.rgbaToCmyk(this.cpService.hsvaToRgba(this.cpService.stringToHsva(color)));
	}

	rgbaToCmyk(rgba: Rgba): Cmyk {
		const cmyk = new Cmyk(0, 0, 0, 0);
		let k: number;
		k = 1 - Math.max(rgba.r, rgba.g, rgba.b);
		cmyk.c = (1 - rgba.r - k) / (1 - k);
		cmyk.m = (1 - rgba.g - k) / (1 - k);
		cmyk.y = (1 - rgba.b - k) / (1 - k);
		cmyk.k = k;
		return cmyk;
	}

	// updateInstitution() {
	// 	// console.log(this.infoData);
	// 	const modalUpdate = document.getElementById("modal-update");
	// 	modalUpdate.classList.remove("show-modal");
	// 	this.router.navigate(["pages"]);
	// 	this.institutionService.updateInstitution(this.infoData).then((result: any) => {
	// 		console.log(result);
	// 	}).catch((err: any) => {
	// 		console.log(err);
	// 	});
	// }
}

